// extracted by mini-css-extract-plugin
export default {"ForumSearch__headline":"pw_a bhe_sl bhe_uy","ForumSearch__img":"pw_b","ForumSearch__searchAdsAndShoppingAds":"pw_c","ForumSearch__results--empty":"pw_e"};